import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop"; // Import ScrollToTop component
import Spinner from "./components/Spinner"; // Import Spinner for loading state
import "./index.css"; // Custom CSS
import '@fortawesome/fontawesome-free/css/all.min.css'; // FontAwesome icons

// Lazy loaded components
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));
const Blog = lazy(() => import("./pages/Client & Partners"));
const Products = lazy(() => import("./pages/Products"));
const Dashboard = lazy(() => import("./pages/CareerSection"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Employee = lazy(() => import("./pages/Employee"));


function App() {
  return (
    
      <Router>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <div className="m-12 md:m-18">
            <Header />
          </div>

          <main className="flex-grow font-roboto">
            <Suspense fallback={<Spinner />}>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/client-partners" element={<Blog />} />
              <Route path="/products" element={<Products />} />
              <Route path="/career" element={<Dashboard />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/team" element={<Employee />} />

              </Routes>
            </Suspense>
          </main>

          <Footer />
        </div>
      </Router>
   
  );
}

export default App;